import { setFeeAuditors } from "../../Redux/FeeAuditorsSlice";
import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import FeeAuditorsService from "../../Services/http/FeeAuditorsService";

export const getFeeAuditors = async (dispatch, accountId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await FeeAuditorsService.getFeeAuditors(accountId);
  dispatch(setIsActiveSpinner(false));
  if (response) {
    dispatch(setFeeAuditors(response));
  }
};

export const updateDimensionInDB = async (dispatch, dimensions, accountId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await FeeAuditorsService.updateDimensionInDB(dimensions);
  dispatch(setIsActiveSpinner(false));
  if (!response || response["message"] !== "success") {
    alert(response["message"]);
  }
  getFeeAuditors(dispatch, accountId);
};

export const updateDimensionsByExcel = async (dispatch, file, accountId) => {
  dispatch(setIsActiveSpinner(true));
  const response = await FeeAuditorsService.importDimensionsExcel(
    accountId,
    file
  );
  dispatch(setIsActiveSpinner(false));
  if (response && response["message"] === "success") {
    getFeeAuditors(dispatch, accountId);
  }
  return response;
};

export const uploadDangerousGoodsByExcel = async (
  dispatch,
  file,
  accountId
) => {
  dispatch(setIsActiveSpinner(true));
  const response = await FeeAuditorsService.importDangerousGoodsExcel(
    accountId,
    file
  );
  dispatch(setIsActiveSpinner(false));
  return response;
};
